export const obtenerHorasDisponibles = (fecha, arrSemana) => {



    let arr = []
    let indexDiaSemana = parseInt(fecha.format('d'))
    let diaSemana = arrSemana[indexDiaSemana]

    if (diaSemana.am) {

        for (let i = diaSemana.inicioAm; i < diaSemana.finAm; i++) {
            let obj1 = {hora: i, minutos: 0, jornada: 'am'}
            let obj2 = {hora: i, minutos: 30, jornada: 'am'}
            arr.push(obj1)
            arr.push(obj2)
        }
    }

    if (diaSemana.pm) {

        for (let i = diaSemana.inicioPm; i < diaSemana.finPm; i++) {
            let obj1 = {hora: i, minutos: 0, jornada: 'pm'}
            let obj2 = {hora: i, minutos: 30, jornada: 'pm'}
            arr.push(obj1)
            arr.push(obj2)
        }
    }


    return arr
}